import { Grid, Typography } from "@mui/material";

import { FairPaySurveyResponse } from "features/FairPaySurvey/schemas";

const styles = {
  badge: {
    my: 2,
    background: "white",
    p: 2,
    borderRadius: "20px",
    border: `1px solid #DFDFDF`,
  },
  chip: {
    py: 1,
    px: 2,
    mb: 1,
    fontWeight: 700,
    fontSize: "18px",
    color: "#151F16",
    borderRadius: "20px",
    border: `1px solid rgba(21, 31, 22, 0.2)`,
  },
  descriptionLargeText: {
    textAlign: "center",
    fontSize: "28px",
    fontWeight: 600,
  },
  unhighlightedBlock: (idx: number) => ({
    backgroundColor: "red",
    height: `${40 * (idx + 1)}px`,
    borderRadius: 3,
    background: `
      repeating-linear-gradient(
        135deg,
        #ECEAE5 0px,
        #ECEAE5 5px,
        rgba(0, 0, 0, 0.15) 5px,
        rgba(0, 0, 0, 0.15) 8px
      )
    `,
  }),
  highlightedBlock: (idx: number) => ({
    backgroundColor: "red",
    height: `${40 * (idx + 1)}px`,
    borderRadius: 3,
    background: "#F7EE6F",
  }),
  descriptionText: { textAlign: "center", maxWidth: "80%" },
};

export default function FollowersPercentile({
  surveyResponse,
}: {
  surveyResponse: FairPaySurveyResponse | null;
}) {
  if (!surveyResponse) {
    return null;
  }

  if (!surveyResponse?.followerCountPercentile) {
    return null;
  }

  const topPercentage =
    100 - Math.round(surveyResponse.followerCountPercentile) || 1;

  return surveyResponse?.followerCount ? (
    <Grid item xs={12} justifyContent="center" container sx={styles.badge}>
      <Typography component="div" sx={styles.chip}>
        {surveyResponse.followerCount} Followers
      </Typography>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionLargeText}>
          🌟 Top {topPercentage}%
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        justifyContent="center"
        alignItems="flex-end"
        container
        gap={2}
        sx={{ my: 2 }}
      >
        <Grid
          item
          xs
          sx={
            surveyResponse.followerCountPercentile <= 25
              ? styles.highlightedBlock(0)
              : styles.unhighlightedBlock(0)
          }
        />
        <Grid
          item
          xs
          sx={
            surveyResponse.followerCountPercentile <= 50 &&
            surveyResponse.followerCountPercentile > 25
              ? styles.highlightedBlock(1)
              : styles.unhighlightedBlock(1)
          }
        />
        <Grid
          item
          xs
          sx={
            surveyResponse.followerCountPercentile <= 75 &&
            surveyResponse.followerCountPercentile > 50
              ? styles.highlightedBlock(2)
              : styles.unhighlightedBlock(2)
          }
        />
        <Grid
          item
          xs
          sx={
            surveyResponse.followerCountPercentile > 75
              ? styles.highlightedBlock(3)
              : styles.unhighlightedBlock(3)
          }
        />
      </Grid>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionText}>
          You're in the top {topPercentage}% for your following!
        </Typography>
      </Grid>
    </Grid>
  ) : (
    <></>
  );
}
